var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { callGraphQL } from '../../common/common';
import { createTripInvitation as createTripInvitationMutation, updateTripInvitation as updateTripInvitationMutation, deleteTripInvitation as deleteTripInvitationMutation } from '../../../graphql/mutations';
/**
 * Create a Trip Invitation
 * @param senderId
 * @param recipientId
 * @param tripId
 * @param permissionType
 */
export function createTripInvitation(senderId, recipientId, tripId, permissionType) {
    return __awaiter(this, void 0, void 0, function* () {
        const params = {
            input: {
                owners: [senderId, recipientId],
                status: TripInvitationStatus.PENDING,
                senderId,
                recipientId,
                tripId,
                permissionType
            }
        };
        return callGraphQL(createTripInvitationMutation, params).then((res) => { var _a; return (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.createTripInvitation; });
    });
}
export var TripInvitationStatus;
(function (TripInvitationStatus) {
    TripInvitationStatus["ACCEPTED"] = "ACCEPTED";
    TripInvitationStatus["PENDING"] = "PENDING";
    TripInvitationStatus["REJECTED"] = "REJECTED";
})(TripInvitationStatus || (TripInvitationStatus = {}));
/**
 * Update a Trip Invitation status
 * @param id
 * @param status
 */
export function updateTripInvitation(id, status) {
    return __awaiter(this, void 0, void 0, function* () {
        const params = {
            input: {
                id,
                status
            }
        };
        return callGraphQL(updateTripInvitationMutation, params).then((res) => { var _a; return (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.updateTripInvitation; });
    });
}
/**
 * Delete a Trip Invitation
 * @param id
 */
export function deleteTripInvitation(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return callGraphQL(deleteTripInvitationMutation, { input: { id: id } }).then((res) => { var _a; return (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.deleteTripInvitation; });
    });
}
